import { z } from "zod";

export const cleanerPlatformInvitationIdSchema = z.string().regex(/^[0-9a-f]{32}$/u);
const isoDateTimeSchema = z.string().datetime({ offset: true });

export const cleanerPlatformInvitationStatusSchema = z.enum([
  "PENDING",
  "ACCEPTED",
  "REVOKED",
  "EXPIRED",
]);

export const cleanerPlatformInvitationSchema = z.strictObject({
  invitationId: cleanerPlatformInvitationIdSchema,
  propertyId: cleanerPlatformInvitationIdSchema,
  inviteeEmail: z.string().nullable(),
  inviteePhoneE164: z.string().nullable(),
  inviteToken: cleanerPlatformInvitationIdSchema,
  status: cleanerPlatformInvitationStatusSchema,
  acceptedCleanerUserId: cleanerPlatformInvitationIdSchema.nullable(),
  acceptedPublicName: z.string().nullable(),
  createdAt: isoDateTimeSchema,
  expiresAt: isoDateTimeSchema.nullable(),
  resolvedAt: isoDateTimeSchema.nullable(),
});

export const existingCleanerLookupSchema = z.strictObject({
  cleanerUserId: cleanerPlatformInvitationIdSchema.nullable(),
  publicName: z.string().nullable(),
});

export const cleanerPlatformInvitationLookupResponseSchema = z.strictObject({
  status: z.literal("ok"),
  cleaner: existingCleanerLookupSchema,
});

export const cleanerPlatformInvitationListResponseSchema = z.strictObject({
  status: z.literal("ok"),
  invitations: z.array(cleanerPlatformInvitationSchema),
});

export const createCleanerPlatformInvitationInputSchema = z.strictObject({
  propertyId: cleanerPlatformInvitationIdSchema,
  inviteeEmail: z.string().trim().max(320).nullable().optional(),
  inviteePhoneE164: z.string().trim().nullable().optional(),
});

export const createCleanerPlatformInvitationResponseSchema = z.strictObject({
  status: z.literal("created"),
  invitation: cleanerPlatformInvitationSchema,
});

export const revokeCleanerPlatformInvitationResponseSchema = z.strictObject({
  status: z.literal("revoked"),
});

export type CleanerPlatformInvitationStatus = z.infer<
  typeof cleanerPlatformInvitationStatusSchema
>;
export type CleanerPlatformInvitation = z.infer<typeof cleanerPlatformInvitationSchema>;
export type ExistingCleanerLookup = z.infer<typeof existingCleanerLookupSchema>;
export type CreateCleanerPlatformInvitationInput = z.infer<
  typeof createCleanerPlatformInvitationInputSchema
>;
